import { render, staticRenderFns } from "./StateRestrictions.vue?vue&type=template&id=06647124"
import script from "./StateRestrictions.vue?vue&type=script&lang=js"
export * from "./StateRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports